export default __webpack_public_path__ + "static/media/img-clients_6.4103e31f.png";